import React, { useRef } from 'react';
import classNames from 'classnames';
import { ActionRail } from './ActionRail';
import { MultiSelectActionRail } from './MultiSelectActionRail';
import { EMAIL_BUILDER_ACTION_RAIL_ATTR } from './actionRailConstants';
import { useEmailBuilderTouchRailPin } from './useEmailBuilderTouchRailPin';

type TouchRailBarProps = {
  frameRef: React.RefObject<HTMLElement | null>;
  multiSelect?: boolean;
};

export function TouchRailBar({
  frameRef,
  multiSelect = false,
}: TouchRailBarProps) {
  const railRef = useRef<HTMLDivElement>(null);
  const { pinned, pinStyle } = useEmailBuilderTouchRailPin({
    enabled: true,
    frameRef,
    railRef,
    placement: 'start',
  });

  return (
    <div
      ref={railRef}
      className={classNames("email-builder-canvas-rail", "email-builder-canvas-rail--vertical", "email-builder-canvas-touch-rail", "email-builder-canvas-touch-rail--vertical", {
        'email-builder-canvas-touch-rail--pinned': pinned,
      })}
      data-editor-chrome
      role="toolbar"
      style={
        pinStyle ?? {
          position: 'fixed',
          visibility: 'hidden',
          pointerEvents: 'none',
          top: 0,
          left: 0,
        }
      }
      {...{ [EMAIL_BUILDER_ACTION_RAIL_ATTR]: '' }}
      onPointerDown={event => event.stopPropagation()}
      onClick={event => event.stopPropagation()}>
      <div className={"email-builder-canvas-touch-rail__scroll"}>
        {multiSelect ? (
          <MultiSelectActionRail layout="inline" />
        ) : (
          <ActionRail layout="inline" />
        )}
      </div>
    </div>
  );
}
